import { AccountMenuItem } from "../../types";
import { OrganizationProfile } from "../profile";
import { Integrations } from "../integrations";
import { OrganizationAddress } from "../address";
import { Features } from "../features/Features";

export const organizationMenus: AccountMenuItem[] = [
  {
    name: "profile",
    displayName: "Profile",
    component: <OrganizationProfile />,
  },
  {
    name: "integrations",
    displayName: "Integrations",
    component: <Integrations />,
  },
  {
    name: "features",
    displayName: "Features",
    component: <Features />,
  },
  {
    name: "address",
    displayName: "Address",
    component: <OrganizationAddress />,
  },
];

export const organizationMenuDefault: AccountMenuItem = organizationMenus[0];
